<template>
  <div class="section mt-1">
    <div class="section-title text-center text-primary">
      Online Meeting Attendance
    </div>

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="submitForm">
          <div class="form-group basic">
            <label class="label text-primary">
              Meeting Name
              <span class="text-danger">*</span>
            </label>
            <div class="input-wrapper">
              <select
                v-model="form.meeting_id"
                class="form-control custom-select"
                required
              >
                <option value="">Select Meeting</option>
                <option
                  v-for="meeting in meetingOptions"
                  :key="meeting.id"
                  :value="meeting.id"
                >
                  {{ meeting.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group basic">
            <label class="label text-primary" for="mobile">
              Mobile Number
              <span class="text-danger">*</span>
            </label>
            <div class="input-wrapper">
              <input
                id="mobile"
                type="tel"
                class="form-control"
                v-model="form.mobile"
                placeholder="Enter mobile number"
                required
                pattern="[0-9]{10,13}"
              />
              <i
                v-if="form.mobile"
                class="clear-input"
                @click="form.mobile = ''"
              >
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
            <small class="text-muted d-block mt-1">
              Enter a valid mobile number (10–13 digits).
            </small>
          </div>

          <div class="form-group basic mb-0">
            <button
              type="submit"
              class="btn btn-primary btn-block btn-lg"
              :disabled="submitting"
            >
              <span
                v-show="submitting"
                class="spinner-border spinner-border-sm"
              ></span>
              <span>Submit</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <alert-model
      :type="alert_type"
      :message="alert_message"
      ref="alert_model"
    ></alert-model>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
  name: "PublicMeetingRegistration",
  components: {
    AlertModel,
  },
  data() {
    return {
      submitting: false,
      alert_type: "",
      alert_message: "",
      form: {
        meeting_id: "",
        mobile: "",
      },
      meetingOptions: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    displayMobile() {
      if (!this.currentUser) return "";

      if (this.currentUser.mobile) {
        return this.currentUser.mobile;
      }

      if (this.currentUser.username) {
        const username = this.currentUser.username.toString();
        const cc = (this.currentUser.country_code || "").toString();

        if (cc && username.startsWith(cc) && username.length > cc.length) {
          return username.substring(cc.length);
        }

        return username;
      }

      return "";
    },
  },
  mounted() {
    if (this.$root && typeof this.$root.updateParent === "function") {
      this.$root.updateParent("Public Meeting Attendance");
    }

    // Pre-fill mobile if user is logged in
    if (this.displayMobile) {
      this.form.mobile = this.displayMobile;
    }

    this.loadMeetings();
  },
  methods: {
    async loadMeetings() {
      try {
        const response = await UserService.PostRequest("public-meetings", {});

        if (
          response.data &&
          response.data.status === "success" &&
          response.data.data &&
          Array.isArray(response.data.data.meetings)
        ) {
          this.meetingOptions = response.data.data.meetings;
        } else {
          this.alert_type = "Warning";
          this.alert_message =
            (response.data && response.data.message) ||
            "Unable to load meetings. Please try again later.";
          this.$refs.alert_model.openModel();
        }
      } catch (error) {
        this.alert_type = "Error";
        this.alert_message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          "Unable to load meetings. Please try again later.";
        this.$refs.alert_model.openModel();
      }
    },

    async submitForm() {
      if (!this.form.meeting_id || !this.form.mobile) {
        this.alert_type = "Warning";
        this.alert_message =
          "Please select a meeting and enter mobile number.";
        this.$refs.alert_model.openModel();
        return;
      }

      this.submitting = true;

      try {
        const payload = {
          meeting_id: this.form.meeting_id,
          mobile: this.form.mobile,
        };

        const response = await UserService.PostRequest(
          "public-meeting-registration",
          payload
        );

        if (response.data && response.data.status === "success") {
          this.alert_type = "Success";
          this.alert_message =
            response.data.message || "Registration submitted successfully.";
          this.form.meeting_id = "";
          this.form.mobile = "";
        } else {
          this.alert_type = "Warning";
          this.alert_message =
            (response.data && response.data.message) ||
            "Unable to submit registration. Please try again.";
        }
      } catch (error) {
        this.alert_type = "Error";
        this.alert_message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          "Something went wrong. Please try again.";
      } finally {
        this.submitting = false;
        this.$refs.alert_model.openModel();
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
}

.card-body {
  padding: 16px 14px 18px;
}

.form-group.basic {
  margin-bottom: 14px;
}

.label {
  font-weight: 600;
  font-size: 14px;
}

.input-wrapper {
  position: relative;
}

.clear-input {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  cursor: pointer;
}

.clear-input ion-icon {
  font-size: 18px;
}
</style>